import { render } from "./OrderTracking.vue?vue&type=template&id=18c15477&scoped=true"
import script from "./OrderTracking.vue?vue&type=script&lang=js"
export * from "./OrderTracking.vue?vue&type=script&lang=js"

import "./OrderTracking.vue?vue&type=style&index=0&id=18c15477&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18c15477"

export default script